import geniatech from "../libs/geniatech";



export const getCities = ({ ...city }) =>
  geniatech.post(`/index.php`, city).then((res) => res.data);

export const getStates = ({ ...state }) =>
  geniatech.post(`/index.php`, state).then((res) => res.data);